module.exports = __webpack_public_path__ + "static/img/coin.8fff50a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coin.png
// module id = jzCB
// module chunks = 1